import { useState } from "react";
import "./conceptual-product-preview.css";

const defaultSteps = [
  { id: "goal", label: "Goal", title: "Start with the commercial objective", description: "Frame what the team sells, where it wants to grow and what it needs to understand." },
  { id: "companies", label: "Companies", title: "Focus the company landscape", description: "Move from a broad market view toward businesses that may deserve further investigation." },
  { id: "stakeholders", label: "Stakeholders", title: "Connect people to the opportunity", description: "Identify roles that may matter within the context of a priority account." },
  { id: "outreach", label: "Outreach", title: "Carry context into activity", description: "Use the account context to support relevant, governed sales communication." },
  { id: "intelligence", label: "Intelligence", title: "Bring new learning forward", description: "Keep useful market, account and interaction context available for the next decision." },
];

export default function ConceptualProductPreview({
  steps = defaultSteps,
  initialStep = 0,
  description = "This illustrative flow shows how Sales OS is designed to connect market context, account focus and next action.",
}) {
  const [activeIndex, setActiveIndex] = useState(Math.min(Math.max(initialStep, 0), steps.length - 1));
  const active = steps[activeIndex];

  return (
    <aside className="concept-preview" aria-label="Conceptual product preview">
      <header className="concept-preview-header">
        <div><span>Conceptual product preview</span><strong>Illustrative product flow</strong></div>
        <p>{description}</p>
      </header>

      <div className="concept-preview-stage">
        <div className="concept-preview-steps" role="tablist" aria-label="Illustrative Sales OS stages">
          {steps.map((step, index) => (
            <button
              aria-controls={`concept-panel-${step.id}`}
              aria-selected={index === activeIndex}
              className={index === activeIndex ? "is-active" : ""}
              id={`concept-tab-${step.id}`}
              key={step.id}
              onClick={() => setActiveIndex(index)}
              role="tab"
              type="button"
            >
              <span>{step.label}</span>
            </button>
          ))}
        </div>

        <section
          aria-labelledby={`concept-tab-${active.id}`}
          className="concept-preview-panel"
          id={`concept-panel-${active.id}`}
          key={active.id}
          role="tabpanel"
          tabIndex="0"
        >
          <div className="concept-preview-context"><span>Context carried forward</span><i aria-hidden="true" /></div>
          <div className="concept-preview-copy"><span>{active.label}</span><h3>{active.title}</h3><p>{active.description}</p></div>
          <div className="concept-preview-next"><span>Supports</span><strong>{steps[(activeIndex + 1) % steps.length].label}</strong></div>
        </section>
      </div>

      <footer className="concept-preview-footer">
        <p><strong>Actual product walkthrough available on request.</strong> Final live product demo will be introduced separately.</p>
        <a href="/book-a-walkthrough">Book a walkthrough</a>
      </footer>
    </aside>
  );
}
